import classNames from 'classnames';

import EdlpPricingSplashSvg from './edlp-pricing-splash.color.svg';
import styles from './EdlpPricingSplash.module.scss';
import {
    type EdlpPricingSplashSize,
    getEdlpPricingSplashSizeClassName,
} from './EdlpPricingSplash.utils';

type EdlpPricingSplashBaseProps = {
    className?: string;
};

type EdlpPricingSplashProps = EdlpPricingSplashBaseProps &
    (
        | {
              /** Predefined CDS token sizing. */
              size: EdlpPricingSplashSize;
              fillContainer?: false;
          }
        | {
              /** Parent is responsible for sizing (e.g. CQ slot). */
              fillContainer: true;
              size?: never;
          }
    );

/**
 * Visual EDLP selection mark. Always decorative — accessible name lives in
 * primary price a11y / product-link aria-label (`EDLP_A11Y_LABEL`).
 */
const EdlpPricingSplash = (props: EdlpPricingSplashProps) => {
    const { className } = props;
    const sizeClassName = props.fillContainer
        ? styles.Fill
        : getEdlpPricingSplashSizeClassName(props.size);

    return (
        <span className={classNames(styles.Splash, sizeClassName, className)} aria-hidden>
            <EdlpPricingSplashSvg aria-hidden focusable="false" />
        </span>
    );
};

export default EdlpPricingSplash;
